export const DOCUMENT_TITLE_MAX_LENGTH = 100;
